import { matchPath } from 'react-router-dom'

import { routes } from 'router/routes'

// Pages that need to handle their own screen_viewed analytics event
const blacklist = [
  '/settings/linked-accounts/:linkedAccountId',
  '/earn/found-money/:owner/:offer/:id',
  '/spend/direct-deposit/search',
  '/grow/:id',
  '/potential/:account',
  '/potential',
  '/closed-account',
  '/spend/signup',
  '/spend/signup/address',
  '/spend/signup/signature',
  '/moc/signature',
  '/spend/signup/confirm',
  '/spend/signup/transfer',
  '/spend/signup/success',
  ...Object.values(routes.early).filter(
    (route) => route !== routes.early.index,
  ),
]

export default (pathname: string) =>
  blacklist.some((path: string) => matchPath(pathname, { path }))
